var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"45","viewBox":"0 0 21 45"}},_vm.$listeners),[_c('path',{attrs:{"fill-rule":"evenodd","d":"M20.156 20.803a1.858 1.858 0 01.409 2.751L3.845 43.481a1.858 1.858 0 11-2.847-2.389l15.678-18.684L.435 3.052A1.858 1.858 0 113.28.664L20 20.59c.058.068.11.14.155.213z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }